//import Libraries
import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Button} from 'reactstrap';

//import Components
import { Modal } from 'reactstrap';
import Language from '../../language/language.json';
import Icons from '../../assets/icons/icons';

import * as modalActions from '../Navigation/actions/modalActions';
import * as mypageActions from '../../pages/MyPage/actions/mypageActions';
//import Style classes
import '../SignIn/SignIn.css'

const logoIcon = Icons.logo

class Widthdraw extends Component {
    constructor(props){
        super(props);
        this.state = {
            nestedModal : '',
            closeAll : false,

            password: '',
            passwordError : ''
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    render() {
        return (
            <div>
                <Modal 
                    isOpen={this.props.modal} 
                    toggle={this.props.toggle}
                    onClosed={this.props.onClosed}
                >
                    <div className="SigninContainer">
                        <div className="Logo">{logoIcon}</div>
                        <div className="Title">
                            {this.props.title}
                        </div>
                        <form>
                            <div className="content">
                                <div className="element">
                                    <input
                                        type="password"
                                        placeholder={this.props.placeholder}
                                        onChange={this.handleOnChange}
                                        value={this.state.password}
                                        name="password"
                                        required />
                                </div>
                                <div className="element">
                                {
                                    this.state.passwordError !== '' && this.state.passwordError
                                }
                                </div>
                                <div className="element">
                                    <Button 
                                        size="lg"
                                        color="info"
                                        className="btn"
                                        onClick={() => {
                                            this.props.onWithdraw( 
                                                this.state.password, {
                                                    successFunc : () => {
                                                        this.props.onToggleModal('withdraw');
                                                        this.props.onToggleModal('withdrawSuccess');
                                                        this.setState({
                                                            password: ''
                                                        })
                                                    },
                                                    failedFunc : (e) => {
                                                        this.setState({
                                                            password: ''
                                                        })
                                                        switch(e.code) {
                                                            case "auth/wrong-password" : {
                                                                this.setState({
                                                                    passwordError : Language.modal.withdraw.errors.wrongPassword[this.props.universal.language]
                                                                })
                                                            }break;
                                                        }
                                                    }
                                            });
                                        }}
                                    >
                                        {this.props.buttonValue}
                                    </Button>
                                </div>
                            </div>
                        </form>
                        <hr/>
                        <div className="footer">
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
        universal : state.universal,
    }
}

const mapDispatchToProps = (dispatch, ownProps)=>{
    return {
        onWithdraw : (password, funcs) => {
            dispatch(mypageActions.withdrawal(password, funcs));
        },
        onToggleModal : (name) => {
            dispatch(modalActions.toggleModal(name));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Widthdraw);


// WEBPACK FOOTER //
// ./src/components/Withdraw/Withdraw.js